<template>
	<v-card flat outlined class="pb-0 pt-0">
		<v-card-text class="pb-0 pt-0">
			<v-row class="pb-0 pt-2">
				<CandidatesRegistrations
					:plannedCourseId="plannedCourseId"
					:canEdit="canEdit"
				></CandidatesRegistrations>
			</v-row>
			<v-row>
				<CandidatesPreregistrations
					:plannedCourseId="plannedCourseId"
					:canEdit="canEdit"
				></CandidatesPreregistrations>
			</v-row>
		</v-card-text>
	</v-card>
</template>

<script>
import CandidatesPreregistrations from './CandidatesPreregistrations';
import CandidatesRegistrations from './CandidatesRegistrations';

export default {
	name: 'Candidates',
	components: { CandidatesPreregistrations, CandidatesRegistrations },
	props: {
		plannedCourseId: [String, Number],
		canEdit: Boolean,
	},
	data() {
		return {};
	},
};
</script>

<style scoped></style>
